import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import LayoutContainer from '@/components/LayoutContainer';
import pageNotFoundImg from '@/assets/web/404.webp';

import styles from './styles.module.less';

const ErrorFallback: React.FC<{
  error: Error;
  componentStack: string;
  onReset?: () => void;
}> = ({ error, componentStack, onReset }) => {
  const isWideScreen = window.innerWidth > 800;

  const { t } = useTranslation(['resource']);

  return (
    <LayoutContainer>
      <div className={isWideScreen ? styles.horizontalLayout : styles.verticalLayout}>
        <img src={pageNotFoundImg} alt='notfound' />
        <div className={styles.titleWrapper}>
          <div dir='auto'>{t('OOPS!')}</div>
          <div dir='auto'>{t('Something went wrong:')}</div>
          <div dir='auto'>{error.toString()}</div>
          <div dir='auto'>{componentStack}</div>
          <Button
            onClick={() => {
              onReset?.();
            }}
            className={styles.btn}
            size='large'
            shape='round'
          >
            {t('Try again')}
          </Button>
        </div>
      </div>
    </LayoutContainer>
  );
};

export default ErrorFallback;
